import * as React from 'react';

export interface ITabProps {
  title: string | JSX.Element;
  className?: string;
  onClick?(history: any): void;
  disabled?: boolean;
}

export default class Tab extends React.Component<ITabProps> {

  render() {
    const {
      title,
      ...props
    } = this.props;
    return (
      <div {...props}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Tabs/Tab.tsx